import { formatOrgLocaleTime } from "@/shared/utils/date/org-time";

/**
 * Converts a timestamp to x-coordinate on the timeline
 */
export const timeToX = (timestamp: number, min: number, max: number, scaledWidth: number): number => {
  if (max === min) return 0;
  return ((timestamp - min) / (max - min)) * scaledWidth;
};

/**
 * Converts an x-coordinate to timestamp
 */
export const xToTime = (x: number, min: number, max: number, scaledWidth: number): number => {
  if (scaledWidth === 0) return min;
  return min + (x / scaledWidth) * (max - min);
};

/**
 * Gets min and max timestamps from event segments
 */
export const getTimestampBounds = (allTimestamps: number[]): [number, number] => {
  if (allTimestamps.length === 0) {
    // Handle empty timeline gracefully - default to 1 hour range
    const now = Date.now();
    return [now - 3600000, now];
  }
  const min = Math.min(...allTimestamps);
  const max = Math.max(...allTimestamps);
  return [min, max];
};

/**
 * Formats a timestamp to time string
 */
export const formatTimeLabel = (timestamp: number): string =>
  formatOrgLocaleTime(timestamp, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
